export interface ChartData {
  [key: string]: any;
}
